import IconButton from '@mui/material/IconButton';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DeleteIcon from '@mui/icons-material/Delete';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

const ActionButtons = ({is_remove_add_btn, addFunction, editFunction, deleteFunction, jobNeedTimeFunction}) => {
    return(
        <>
            {is_remove_add_btn ? (
                <IconButton edge="end">
                    <AddBoxIcon 
                        onClick = {addFunction}
                    />
                </IconButton>
            ) : null}

            <IconButton edge="end">
                <DriveFileRenameOutlineIcon 
                    onClick = {editFunction}
                />
            </IconButton>

            <IconButton edge="end">
                <WorkHistoryIcon 
                    onClick = {jobNeedTimeFunction}
                />
            </IconButton>

            <IconButton edge="end">
                <DeleteIcon 
                    onClick = {deleteFunction}
                />
            </IconButton>
        </>
    );
}

export default ActionButtons